<template>
  <van-row gutter="20">
    <van-col :span='titleSpan' class='col-title'>
      {{ title }}
    </van-col>
    <van-col :span='24 - titleSpan'>
      <van-radio-group v-model="val" :direction="direction">
        <van-radio v-for='item in options' :key='item.id' :name="item.name">
          {{ item.label }}
        </van-radio>
      </van-radio-group>
    </van-col>
  </van-row>
</template>

<script>
export default {
  data() {
    return {
      val: String(this.initVal)
    }
  },
  props: {
    title: {
      type: String,
      default: null
    },
    titleSpan: {
      type: Number,
      default: 6
    },
    initVal: {
      type: Number,
      default: 1
    },
    options: {
      type: Array,
      default: () => new Array()
    },
    direction: {
      type: String,
      default: 'horizontal'
    }
  },
  watch: {
    val(val) {
      this.$emit('change', val);
    }
  }
}
</script>

<style scoped>
.col-title {
  text-align: right;
}
</style>


// WEBPACK FOOTER //
// src/components/base/BaseRadioGroup.vue